<template>
  <div>
    <v-btn
      block
      class="background rounded-pill my-4"
      dark
      @click.stop="dialogForm = true"
      ><v-icon class="mr-4">mdi-home-currency-usd</v-icon> Nouveau Cycle
      GEC</v-btn
    >
    <v-dialog
      v-model="dialogForm"
      fullscreen
      hide-overlay
      transition="slide-x-transition"
    >
      <v-card>
        <v-app-bar class="transparent" light flat>
          <v-toolbar-title>
            <v-btn icon @click="dialogForm = false">
              <v-icon>mdi-arrow-left</v-icon> </v-btn
            >Nouveau cycle Gec : {{ groupe.nom_groupe }}
          </v-toolbar-title>
        </v-app-bar>
        <v-card-text>
          <v-form ref="form" lazy-validation>
            <v-container fluid>
              <v-row no-gutters="">
                <v-col cols="12">
                  <v-text-field
                    dense
                    v-model="tarif_part"
                    label="Tarif part (Ar)"
                    prepend-icon="person"
                    :rules="requis"
                    required
                    type="number"
                  ></v-text-field>
                </v-col>

                <v-col cols="12">
                  <v-autocomplete
                    v-model="nombreSemaine"
                    ref="nombreSemaine"
                    dense
                    :items="cycles"
                    label="Nombre de semaines"
                    outlined
                    :rules="selectRules"
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12">
                  <v-menu
                    v-model="menu2"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    max-width="290px"
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        :value="computedDateDebutFormattedMomentjs"
                        label="Date de début de cycle"
                        prepend-icon="mdi-calendar-cursor"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        :rules="requis"
                        required
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      locale="fr"
                      v-model="date_debut"
                      no-title
                      @input="menu2 = false"
                    ></v-date-picker>
                  </v-menu>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </v-card-text>

        <v-card-actions class="pb-4">
          <v-btn class="rounded-pill neumorphic warning" @click="reset"
            >Annuler</v-btn
          >
          <v-btn
            class="rounded-pill neumorphic primary"
            :loading="newLoading"
            @click="create"
            >Créer le cycle GEC</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
export default {
  data() {
    return {
      newLoading: false,
      dialogForm: false,
      requis: [
        (v) => !!v || "Ce champ est obligatoire",
        (v) => (v && v.length >= 3) || "Au moins trois caractères",
      ],
      emailRules: [
        (v) => !!v || "E-mailrequis",
        (v) => /.+@.+\..+/.test(v) || "E-mail invalide",
      ],
      selectRules: [(v) => !!v || "Veuillez sélectionner une valeur"],
      cycles: ["52", "39"],
      tarif_part: "1000",
      menu2:false,
      nombreSemaine:"",
      date_debut:""
    };
  },
  props: {
    groupe: {
      type: Object,
      required: true,
    },
  },
  methods: {
    create() {
      if (this.$refs.form.validate()) {
        var self = this;
        this.newLoading = true;
        console.log("validé");
        this.newLoading = false;
      } else {
        console.log("veillez valide d'abord");
      }
    },
    reset() {
      this.$refs.form.reset();
      this.communes = [];
      this.newLoading = false;
      this.dialogForm = false;
    },
  },
   computed: {
    computedDateDebutFormattedMomentjs() {
      return this.date_debut
        ? this.$moment(this.date_debut).format("DD-MM-YYYY")
        : "";
    },

    ...mapState({
     
    }),
  },
};
</script>

<style lang="scss" scoped></style>
